interface Branch {
  name: string;
  url: string;
  comment: string;
  branches?: [];
}

export default {
  state: {
    branches: [
      {
        name: "master",
        url: "",
        comment: "",
        branches: [
          {
            name: "develop",
            url: "",
            comment: "",
            branches: [
              {
                name: "",
                url: "",
                comment: "",
                branches: []
              }
            ]
          }
        ]
      }
    ]
  },
  initData() {
    return this.state.branches;
  },
  removeBranch(level: number, position: [number, number, number]) {
    switch (level) {
      case 0:
        break;
      case 1:
        this.state.branches[0].branches.splice(position[1], 1);
        break;
      case 2:
        this.state.branches[0].branches[position[1]].branches.splice(
          position[2],
          1
        );
        break;
      default:
        break;
    }
  },
  addChildBranch(level: number, position: [number, number, number]) {
    const newData = {
      name: "",
      url: "",
      comment: "",
      branches: []
    };
    switch (level) {
      case 0:
        this.state.branches[0].branches.push(newData);
        break;
      case 1:
        this.state.branches[0].branches[position[1]].branches.push(newData);
        break;
      default:
        break;
    }
  }
};
